import { observer } from "mobx-react";
import * as React from "react";
import { Classes, Dialog } from "@blueprintjs/core";

interface Props {
  title: string
  open: boolean
  onClose: () => void;
}

@observer
export class LoadingModal extends React.Component<Props, {}> {

  constructor(props) {
    super(props);
  }

  render() {

    return (

      <Dialog isOpen={this.props.open} className="modal-loading" onClose={() => this.props.onClose()}>

        <div className={Classes.DIALOG_BODY}>

          <div style={{ width: "100%", margin: 0, padding: 0, textAlign: "center" }}>

            <div className="spinner-loading spinner-border" role="status">

              <span className="sr-only"></span>

            </div>

            <h2 className="title-loading">{this.props.title} ...</h2>

          </div>

        </div>

      </Dialog>

    );

  }

}

export default LoadingModal;
